/**
 * Pre-launch mode helper.
 *
 * Flip REACT_APP_LAUNCHED=true in /app/frontend/.env when we go live.
 * While false: /register, /post-job, /dashboard/*, /find-trades (empty), etc.
 * all redirect to the waitlist landing at "/". Admin can still reach /login
 * and /admin directly via URL.
 */

export function isLaunched() {
  // Treat anything that isn't literally the string "true" as pre-launch.
  return (process.env.REACT_APP_LAUNCHED || "").toLowerCase() === "true";
}

// Small helper for components that want a boolean-ish check.
export const LAUNCHED = isLaunched();
